import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { pickHTMLProps } from 'pick-react-known-prop';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      gridGap: theme.spacing(1),
      display: 'grid',
      justifyItems: 'center',
      gridTemplateAreas: "\n        \"image\"\n        \"name\"\n        \"price\"\n        \"addToCart\"\n      ",
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 45px 40px'
    }
  };
}, {
  name: 'SxComProductListItemCard'
});

function ProductListItemCard(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className"]);

  var classes = useStyles({
    classes: pClasses,
    className: className
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: classes.root
  }), children);
}

ProductListItemCard.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string
};
ProductListItemCard.defaultProps = {
  classes: undefined,
  className: undefined
};
export default ProductListItemCard;